import { Gender } from '../api/hscan/account';

export function genderToString(gender: string | Gender | undefined) {
  if (gender === Gender.F) {
    return 'female';
  }
  if (gender === Gender.M) {
    return 'male';
  }
  if (gender === Gender.O) {
    return 'others';
  }
  return 'others';
}

export type NonOptionalKeys<T> = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  [K in keyof T]-?: {} extends Pick<T, K> ? never : K;
}[keyof T];

// https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?sid1=
export const getEpostTrackingUrl = (trackingNumber: string | undefined) => {
  return trackingNumber
    ? `https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?sid1=${trackingNumber}`
    : undefined;
};
